import { mergeData } from '@/core/item_assistance/mergeItemData'
import { showMessageAlert } from '@/core/shared'
import { UPDATE_ITEM_DATA } from 'actions/configurations'
import { recursiveCalculations } from 'utils/calculations'

export let expressionCalculate = {
	methods: {
		expressionCalculate: function (itemData = this.$store.getters.getItemData) {
			if (this.expression === '' || !this.expression) {
				return ''
			}
			const itemStructure = this.$store.getters.getItemStructure
			const transformed = recursiveCalculations(this.expression, itemData, itemStructure, this)
			let result = transformed.evaluate()
			return result || ''
		},
		recalculateAttribute: function () {
			let unsavedData = JSON.parse(JSON.stringify(editableTradeItem.unsavedDataManager.getUnsavedData()))
			let itemData = this.itemData

			if (typeof itemData[this.attributeName] === 'undefined') {
				itemData[this.attributeName] = this.attributeValue
			}
			itemData = mergeData(itemData, unsavedData)

			if (itemData[this.attributeName] && itemData[this.attributeName].hasOwnProperty('val')) {
				itemData[this.attributeName] = {
					'val': this.expressionCalculate(itemData),
					'mu': this.attributeValue.mu
				}
			} else {
				itemData[this.attributeName] = this.expressionCalculate(itemData)
			}
			alert(this.$t(this.localizedTitle), this)

			this.attributeValue = itemData[this.attributeName]

			this.$store.dispatch(UPDATE_ITEM_DATA, itemData).then(() => {})
		}
	}
}

function alert (attribute, context) {
	editableTradeItem.unsavedDataManager.changesRegister(context.attributeName)
	showMessageAlert(context.$t('attribute.recalculated', [attribute]), 'success')
}
